import { Skeleton } from "@/components/ui/skeleton";

interface Props {
  variant?: "standard" | "horizontal" | "compact" | "overlay";
  className?: string;
}

export function ArticleCardSkeleton({
  variant = "standard",
  className = "",
}: Props) {
  if (variant === "overlay") {
    return (
      <Skeleton className={`rounded-lg ${className || "aspect-[16/10]"}`} />
    );
  }
  if (variant === "horizontal") {
    return (
      <div className={`flex gap-4 items-start ${className}`}>
        <Skeleton className="w-28 h-20 md:w-36 md:h-24 rounded-md flex-shrink-0" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-20" />
        </div>
      </div>
    );
  }
  if (variant === "compact") {
    return (
      <div className="space-y-2">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-3 w-20" />
      </div>
    );
  }
  return (
    <div className={`space-y-3 ${className}`}>
      <Skeleton className="aspect-[16/10] rounded-lg w-full" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-3 w-24" />
    </div>
  );
}

export function ArticleGridSkeleton({
  count = 6,
  cols = "sm:grid-cols-2 lg:grid-cols-3",
}: {
  count?: number;
  cols?: string;
}) {
  return (
    <div className={`grid grid-cols-1 ${cols} gap-5`}>
      {Array.from({ length: count }).map((_, i) => (
        <ArticleCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function HeroSkeleton() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-8">
      <Skeleton className="lg:col-span-2 aspect-[16/10] lg:aspect-auto lg:min-h-[420px] rounded-lg" />
      <div className="flex flex-col gap-4">
        <Skeleton className="aspect-[16/9] flex-1 rounded-lg" />
        <Skeleton className="aspect-[16/9] flex-1 rounded-lg" />
      </div>
    </div>
  );
}

export function ArticlePageSkeleton() {
  return (
    <div className="container py-8">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-4">
          <Skeleton className="h-5 w-20" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-3/4" />
          <Skeleton className="h-4 w-40 mb-6" />
          <Skeleton className="aspect-[16/9] rounded-lg w-full" />
          <div className="space-y-3 mt-6">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-5/6" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-4/5" />
          </div>
        </div>
        <div className="space-y-4">
          <Skeleton className="h-32 w-full rounded-lg" />
          <Skeleton className="h-64 w-full rounded-lg" />
        </div>
      </div>
    </div>
  );
}
